import { ReactNode, useEffect, useState } from 'react'

interface GradientBackgroundProps {
  children: ReactNode
}

export function GradientBackground({ children }: GradientBackgroundProps) {
  const [gradientColor, setGradientColor] = useState('#7ec876')
  
  useEffect(() => {
    const colors = [
      '#7ec876', '#4da6ff', '#ff6b6b', '#ffd93d', '#a78bfa', '#f472b6', '#34d399', '#f59e0b'
    ]
    const interval = setInterval(() => {
      setGradientColor(colors[Math.floor(Math.random() * colors.length)])
    }, 3333)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="relative min-h-screen">
      {/* Gradiente di sfondo */}
      <div 
        className="fixed inset-0 pointer-events-none z-0"
        style={{
          background: `linear-gradient(to bottom, #7ec876 0%, ${gradientColor} 85%, #CFCFCF 100%)`
        }}
      />
      <div className="relative z-10">
        {children}
      </div>
    </div>
  )
}
